import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import Actions from 'datamodel/SearchFilters/actions';
import { getToken, isLoggedUser } from 'datamodel/Auth/selectors';
import envVars from 'base/shared/Env';
import { getAPIUrl as getServerUrl } from 'base/shared/Utils';
import { translate } from 'base/shared/Localization';

const cities = [
  {
    key: 'barcelona',
    label: 'Barcelona',
    searchPath: '/s/Barcelona--Espa%C3%B1a',
    queryParams:
      '?et-search-sorting=relevance&et-search-source=search-bar&marketplaceSegmentBadiRooms=true&bounds=41.4682974272428%2C2.22804492421789%3B41.31703848925413%2C2.052333262952554&center=41.3873974%2C2.168568&d=11.164609446567885&city=Barcelona&pid=ChIJ5TCOcRaYpBIRCmZHTz37sEQ&z=12',
    placeId: 'ChIJ5TCOcRaYpBIRCmZHTz37sEQ',
  },
  {
    key: 'madrid',
    label: 'Madrid',
    searchPath: '/s/Madrid--Espa%C3%B1a',
    queryParams:
      '?et-search-sorting=relevance&et-search-source=search-bar&marketplaceSegmentBadiRooms=true&bounds=40.5630136%2C-3.5240722%3B40.3125792%2C-3.8352242&center=40.4167754%2C-3.7037902&d=11.164609446567885&city=Madrid&pid=ChIJgTwKgJcpQg0RaSKMYcHeNsQ&z=12',
    placeId: 'ChIJgTwKgJcpQg0RaSKMYcHeNsQ',
  },
];

const Badge = styled.span`
  display: inline-block;
  background: linear-gradient(90deg, #ffe29a 0%, #ffc66c 100%);
  color: #111827;
  font-weight: 600;
  border-radius: 9999px;
  padding: 0.3em 1em;
  font-size: 1rem;
  margin: 0 auto 2rem auto;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  color: #4b5563;
  margin-bottom: 1.5rem;
`;

const ToggleWrapper = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 2rem;
`;

const ToggleButton = styled.button`
  background: ${({ active }) => (active ? 'transparent' : 'transparent')};
  color: ${({ active }) => (active ? '#283618' : '#283618')};
  border: 1.5px solid ${({ active }) => (active ? '#283618' : '#283618')};
  border-radius: 9999px;
  padding: 0.5em 1em;
  font-size: 0.85rem;
  font-weight: ${({ active }) => (active ? '300' : '300')};
  cursor: ${({ active }) => (active ? 'default' : 'pointer')};
  transition:
    background 0.2s,
    color 0.2s,
    font-weight 0.2s,
    opacity 0.2s;
  outline: none;
  opacity: ${({ active }) => (active ? '1' : '0.15')};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s;
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
`;

const CardImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 12px;
  border-bottom: none;
`;

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  background: #e0e7ef;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #bdbdbd;
  flex-direction: column;
  font-weight: 400;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
`;

const PriceBadge = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  background: #fff;
  color: #111827;
  font-weight: 500;
  border-radius: 9999px;
  padding: 0.2em 1em;
  font-size: 0.8rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const CardBody = styled.div`
  padding: 2rem 1.2rem 1.5rem 1.2rem;
  background: #fcf6ed;
  border-radius: 0 0 24px 24px;
`;

const CardTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 500;
  color: #111827;
  margin-bottom: 0.3rem;
  line-height: 1.2;
`;

const CardAddress = styled.p`
  color: #222;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  font-weight: 400;
`;

const CardDetails = styled.p`
  color: #222;
  font-size: 0.95rem;
  margin-bottom: 0;
  font-weight: 400;
`;

const DiscoverButton = styled.button`
  background: #283618;
  color: #fff;
  border: none;
  border-radius: 0.5rem;
  padding: 1.1rem 2.5rem;
  font-size: 1.15rem;
  font-weight: 600;
  cursor: pointer;
  margin: 0 auto;
  display: block;
  margin-bottom: 2rem;
  transition: background 0.2s;
  &:hover {
    background: #1b2512;
  }
`;

const Container = styled.div`
  background: #fcf6ed;
  border-radius: 14px;
  padding: 3.5rem 2rem 2rem 2rem;
  max-width: 1200px;
  margin: 2rem auto;
`;

const RoomCollections = ({ router, setMarketplaceSegmentsFilters, token, isLoggedIn }) => {
  // Local state for collections
  const [roomCollections, setRoomCollections] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [selectedCity, setSelectedCity] = useState('barcelona');
  const [imgErrors, setImgErrors] = useState({});

  // Get the place ID for the currently selected city
  const getCurrentPlaceId = () => {
    const cityObj = cities.find((c) => c.key === selectedCity);
    return cityObj?.placeId;
  };

  // Function to fetch room collections directly
  const fetchRoomCollections = async (placeId) => {
    if (!token || !placeId) return;

    setLoading(true);
    setError(null);

    try {
      console.log('Fetching room collections for place ID:', placeId);
      console.log('User logged in:', isLoggedIn);
      console.log('Selected city:', selectedCity);

      // Use the same API endpoint as the Redux action
      const { BADI_ROOMS_COLLECTIONS } = envVars();
      const serverUrl = getServerUrl(BADI_ROOMS_COLLECTIONS);
      const params = { place_id: placeId };

      // Build the URL with query parameters
      const url = new URL(serverUrl);
      Object.keys(params).forEach((key) => {
        url.searchParams.append(key, params[key]);
      });

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('API response:', data);
      setRoomCollections(data);
    } catch (err) {
      console.error('Error fetching room collections:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch collections when selected city changes or on component mount
  useEffect(() => {
    const currentPlaceId = getCurrentPlaceId();
    if (token && currentPlaceId) {
      fetchRoomCollections(currentPlaceId);
    }
  }, [token, isLoggedIn, selectedCity]); // Add selectedCity as dependency

  // Get rooms for selected city from API response
  const getRoomsForCity = () => {
    // The API returns data in the structure: {data: {collections: [{id: "badi_homes", rooms: [...]}]}}
    const collections = roomCollections?.data?.collections;

    if (!collections || !collections.length) {
      console.log('No collections found in API response');
      return [];
    }

    // Find the "badi_homes" collection which contains the rooms
    const badiHomesCollection = collections.find((collection) => collection.id === 'badi_homes');

    if (!badiHomesCollection) {
      console.log('No badi_homes collection found');
      return [];
    }

    console.log('Found badi_homes collection:', badiHomesCollection);
    console.log('Rooms in collection:', badiHomesCollection.rooms);

    // Return only the first 4 rooms
    return (badiHomesCollection.rooms || []).slice(0, 4);
  };

  const rooms = getRoomsForCity();
  const cityObj = cities.find((c) => c.key === selectedCity);

  const handleDiscover = () => {
    setMarketplaceSegmentsFilters({
      filters: {
        badiRooms: true,
        badiCommunity: false,
      },
    });
    router.push(`${cityObj.searchPath}${cityObj.queryParams}`);
  };

  // Show loading state
  if (loading) {
    return (
      <Container>
        <Badge>{translate('v2.roomCollections.badge')}</Badge>
        <Title>{translate('v2.roomCollections.title')}</Title>
        <Subtitle>{translate('v2.roomCollections.subtitle')}</Subtitle>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          {translate('v2.roomCollections.loading')}
        </div>
      </Container>
    );
  }

  // Show error state
  if (error) {
    return (
      <Container>
        <Badge>{translate('v2.roomCollections.badge')}</Badge>
        <Title>{translate('v2.roomCollections.title')}</Title>
        <Subtitle>{translate('v2.roomCollections.subtitle')}</Subtitle>
        <div style={{ textAlign: 'center', padding: '2rem', color: '#ef4444' }}>
          {translate('v2.roomCollections.error')}
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <Badge>{translate('v2.roomCollections.badge')}</Badge>
      <Title>{translate('v2.roomCollections.title')}</Title>
      <Subtitle>{translate('v2.roomCollections.subtitle')}</Subtitle>
      <ToggleWrapper>
        {cities.map((city) => (
          <ToggleButton
            key={city.key}
            active={selectedCity === city.key}
            onClick={() => setSelectedCity(city.key)}
            disabled={selectedCity === city.key}
          >
            {city.label}
          </ToggleButton>
        ))}
      </ToggleWrapper>
      <Grid>
        {rooms.map((room) => (
          <div
            key={room.id}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              background: 'transparent',
            }}
          >
            <CardImageWrapper style={{ marginBottom: '1rem' }}>
              {!imgErrors[room.id] && room.cover_picture?.width_500_url ? (
                <CardImage
                  src={room.cover_picture.width_500_url}
                  alt={room.title}
                  onError={() => setImgErrors((prev) => ({ ...prev, [room.id]: true }))}
                />
              ) : (
                <Placeholder>🛏️</Placeholder>
              )}
              <PriceBadge>
                {room.monthly_price?.current
                  ? `${room.monthly_price.current}€/${room.monthly_price.currency ? room.monthly_price.currency.toLowerCase() : 'month'}`
                  : translate('v2.roomCollections.priceOnRequest')}
              </PriceBadge>
            </CardImageWrapper>
            <CardTitle>
              {translate('v2.roomCollections.roomPrefix')} {room.title}
            </CardTitle>
            <CardAddress>
              {room.neighborhood || translate('v2.roomCollections.locationUnavailable')}
            </CardAddress>
            <CardDetails>{room.details || ''}</CardDetails>
          </div>
        ))}
      </Grid>
      {rooms.length > 0 && (
        <DiscoverButton onClick={handleDiscover}>
          {translate('v2.roomCollections.button')}
        </DiscoverButton>
      )}
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setMarketplaceSegmentsFilters: (filters) =>
    dispatch(Actions.setMarketplaceSegmentsFilters(filters)),
});

const mapStateToProps = (state) => ({
  token: getToken(state),
  isLoggedIn: isLoggedUser(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoomCollections));
